import lib from '@/library'
import config from '@/config'

let marketGroupDefaultProperties = {
  events: [],
  idfwmarketgroup: 'recommended'
}

let trendingMarketGroupDefaultProperties = {
  events: [],
  idfwmarketgroup: 'trending'
}

let eventMarketGroupDefaultProperties = {
  idfwmarkettypeclassgroup: 'recommended',
  name: 'Recommended'
}

const state = {
  recommendedEventIds: [],
  recommendedMarketsIds: null,
  recommendedEventsMarketGroup: marketGroupDefaultProperties,
  recommendedMarketsEventMarketGroup: Object.assign({}, eventMarketGroupDefaultProperties),
  recommendedEventsLoading: false,
  recommendedMarketsLoading: config.app.autoconf.PLAYER_PERSONALISATION.enableRecommendedMarkets || false,
  resetTimeoutIntervalOnLogin: false,
  recommendedEventsTabActive: false,
  recommendedMarketsTabAcvtive: false,
  trendingEventIds: [],
  trendingEventsMarketGroup: trendingMarketGroupDefaultProperties,
  trendingEventsLoading: false,
  trendingEventsTabActive: false,
  liveRecommendedEventsTabActive: false
}

const getters = {
  getRecommendedEventIds (state) {
    return state.recommendedEventIds
  },
  getRecommendedEventsMarketGroup (state) {
    return state.recommendedEventsMarketGroup
  },
  getRecommendedMarketsIds (state) {
    return state.recommendedMarketsIds
  },
  getRecommendedMarketsEventMarketGroup (state) {
    return state.recommendedMarketsEventMarketGroup
  },
  getRecommendedEventsLoading (state) {
    return state.recommendedEventsLoading
  },
  getRecommendedMarketsLoading (state) {
    return state.recommendedMarketsLoading
  },
  getResetTimeoutIntervalOnLogin (state) {
    return state.resetTimeoutIntervalOnLogin
  },
  getRecommendedEventsTabActive (state) {
    return state.recommendedEventsTabActive
  },
  getRecommendedMarketsTabAcvtive (state) {
    return state.recommendedMarketsTabAcvtive
  },
  getTrendingEventIds (state) {
    return state.trendingEventIds
  },
  getTrendingEventsMarketGroup (state) {
    return state.trendingEventsMarketGroup
  },
  getTrendingEventsLoading (state) {
    return state.trendingEventsLoading
  },
  getTrendingEventsTabActive (state) {
    return state.trendingEventsTabActive
  },
  getLiveRecommendedEventsTabActive (state) {
    return state.liveRecommendedEventsTabActive
  }
}

const mutations = {
  setRecommendedEventIds (state, data) {
    state.recommendedEventIds = data
  },
  setRecommendedEventsMarketGroup (state, data) {
    state.recommendedEventsMarketGroup = data
  },
  setRecommendedMarketsIds (state, data) {
    state.recommendedMarketsIds = data
  },
  setRecommendedMarketsEventMarketGroup (state, data) {
    state.recommendedMarketsEventMarketGroup = data
  },
  setRecommendedEventsLoading (state, data) {
    state.recommendedEventsLoading = data
  },
  setRecommendedMarketsLoading (state, data) {
    state.recommendedMarketsLoading = data
  },
  setResetTimeoutIntervalOnLogin (state, data) {
    state.resetTimeoutIntervalOnLogin = data
  },
  setRecommendedEventsTabActive (state, data) {
    state.recommendedEventsTabActive = data
  },
  setRecommendedMarketsTabAcvtive (state, data) {
    state.recommendedMarketsTabAcvtive = data
  },
  setTrendingEventIds (state, data) {
    state.trendingEventIds = data
  },
  setTrendingEventsMarketGroup (state, data) {
    state.trendingEventsMarketGroup = data
  },
  setTrendingEventsLoading (state, data) {
    state.trendingEventsLoading = data
  },
  setTrendingEventsTabActive (state, data) {
    state.trendingEventsTabActive = data
  },
  setLiveRecommendedEventsTabActive (state, data) {
    state.liveRecommendedEventsTabActive = data
  }
}

const actions = {
  fetchRecommendedMarkets (context, eventId) {
    let userId = (localStorage.customer === 'undefined' ? null : localStorage.customer)
    return lib.rpcService.callBroker('personalization', 'getrecommendedmarkets', {
      'eventId': eventId,
      'uid': userId
    }).then(response => {
      if (response && response.result && response.result.eventmarketgroups && response.result.eventmarketgroups.length) {
        let eventMarketGroup = Object.assign({}, eventMarketGroupDefaultProperties)
        Object.assign(eventMarketGroup, response.result.eventmarketgroups[0])
        eventMarketGroup.idfwmarkettypeclassgroup = 'recommended'
        context.commit('setRecommendedMarketsEventMarketGroup', eventMarketGroup)
      } else {
        context.commit('setRecommendedMarketsEventMarketGroup', eventMarketGroupDefaultProperties)
      }
    }).catch((error) => {
      console.error(error)
      context.commit('setRecommendedMarketsEventMarketGroup', eventMarketGroupDefaultProperties)
    }).finally(() => {
      context.commit('setRecommendedMarketsLoading', false)
    })
  },
  fetchRecommendedEvents (context, payload) {
    const userId = payload && payload.userId ? payload.userId : null
    const sportTypeId = payload && payload.sportTypeId ? payload.sportTypeId : null
    const competitionId = payload && Array.isArray(payload.competitionId)
      ? payload.competitionId
      : []

    const params = {
      uid: userId
    }

    const eventsCount = config.app.autoconf.PLAYER_PERSONALISATION.recommendedEventsCount

    if (eventsCount) {
      params.eventsCount = eventsCount
    }

    if (!competitionId.length && sportTypeId) {
      params.sportTypeId = sportTypeId
    }

    const competitionIdQuery =
      competitionId.length
        ? competitionId
          .filter(Boolean)
          .map(id => `competitionId=${encodeURIComponent(String(id))}`)
          .join('&')
        : ''

    const endpoint = competitionIdQuery
      ? `getRecommendedEventsArray?${competitionIdQuery}`
      : 'getRecommendedEventsArray'

    return lib.rpcService.callBroker('personalization', endpoint, params).then(eventIdsResponse => {
      const eventIds = eventIdsResponse && Array.isArray(eventIdsResponse.result)
        ? eventIdsResponse.result.filter(Boolean)
        : []

      if (eventIds.length) {
        context.commit('setRecommendedEventIds', eventIds)

        lib.kansas.psFavEvents({ csvlist: eventIds.join(',') }).then((eventsResponse) => {
          if (eventsResponse && eventsResponse.data && eventsResponse.data.events && eventsResponse.data.events.length) {
            let marketGroup = Object.assign({}, marketGroupDefaultProperties)
            Object.assign(marketGroup, eventsResponse.data)
            marketGroup.events.forEach((ev) => {
              if (ev.tsstart && ev.tsstart.indexOf('T') > -1) {
                ev.tsdate = ev.tsstart.split('T')[0]
              } else {
                ev.tsdate = '0'
              }
            })
            context.commit('setRecommendedEventsMarketGroup', marketGroup)
          } else {
            context.commit('setRecommendedEventsMarketGroup', marketGroupDefaultProperties)
          }
        }).catch((error) => {
          console.log(error)
          context.commit('setRecommendedEventsMarketGroup', marketGroupDefaultProperties)
        }).finally(() => {
          context.commit('setRecommendedEventsLoading', false)
        })
      } else {
        context.commit('setRecommendedEventIds', [])
        context.commit('setRecommendedEventsMarketGroup', marketGroupDefaultProperties)
        context.commit('setRecommendedEventsLoading', false)
      }
    }).catch((error) => {
      console.log(error)
      context.commit('setRecommendedEventIds', [])
      context.commit('setRecommendedEventsMarketGroup', marketGroupDefaultProperties)
      context.commit('setRecommendedEventsLoading', false)
    }).finally(() => {
      context.commit('setResetTimeoutIntervalOnLogin', false)
    })
  },
  fetchTrendingEvents (context, payload) {
    const userId = payload && payload.userId ? payload.userId : null
    const sportTypeId = payload && payload.sportTypeId ? payload.sportTypeId : null
    const competitionId = payload && Array.isArray(payload.competitionId)
      ? payload.competitionId.filter(Boolean)
      : []

    const endpoint = 'getTrendingEventIds'
    const params = {}

    const eventsCount = config.app.autoconf.PLAYER_PERSONALISATION.trendingEventsCount

    if (eventsCount) {
      params.eventsCount = eventsCount
    }

    if (userId !== null && userId !== undefined) {
      params.uid = userId
    }

    if (competitionId.length) {
      params.csvCompetitions = competitionId.join(',')
    } else if (sportTypeId) {
      params.csvSports = sportTypeId
    }

    context.commit('setTrendingEventsLoading', true)

    return lib.rpcService.callBroker('personalization', endpoint, params).then(eventIdsResponse => {
      const eventIds = eventIdsResponse && Array.isArray(eventIdsResponse.result)
        ? eventIdsResponse.result.filter(Boolean)
        : []

      context.commit('setTrendingEventIds', eventIds)

      if (!eventIds.length) {
        context.commit('setTrendingEventsMarketGroup', Object.assign({}, trendingMarketGroupDefaultProperties))
        return null
      }

      const csv = eventIds.join(',')

      return lib.kansas.psFavEvents({ csvlist: csv }).then(eventsResponse => {
        const events = eventsResponse &&
        eventsResponse.data &&
        Array.isArray(eventsResponse.data.events)
          ? eventsResponse.data.events
          : []

        if (events.length) {
          let marketGroup = Object.assign({}, trendingMarketGroupDefaultProperties)
          Object.assign(marketGroup, eventsResponse.data)
          marketGroup.idfwmarketgroup = 'trending'

          marketGroup.events.forEach(ev => {
            if (ev.tsstart && ev.tsstart.indexOf('T') > -1) {
              ev.tsdate = ev.tsstart.split('T')[0]
            } else {
              ev.tsdate = '0'
            }
          })

          context.commit('setTrendingEventsMarketGroup', marketGroup)
        } else {
          context.commit('setTrendingEventsMarketGroup', Object.assign({}, trendingMarketGroupDefaultProperties))
        }

        return eventsResponse
      }).catch(error => {
        console.log(error)

        context.commit('setTrendingEventsMarketGroup', Object.assign({}, trendingMarketGroupDefaultProperties))
        return null
      }).finally(() => {
        context.commit('setTrendingEventsLoading', false)
      })
    }).catch(error => {
      console.log(error)

      context.commit('setTrendingEventIds', [])
      context.commit('setTrendingEventsMarketGroup', Object.assign({}, trendingMarketGroupDefaultProperties))

      return null
    }).finally(() => {
      context.commit('setTrendingEventsLoading', false)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/sports/vaixtabs.js